import React from 'react';

import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';

import { generalDataLeft, generalDataRight } from './collinsMpcConstants';
import { getAttributeDataRows } from './collinsMpcUtilities';

import './collinsMpcPdfReport.css';

interface Props {
  workOrderAsset: any;
}

const GeneralData = ({ workOrderAsset }: Props) => {
  const dataLeft = getAttributeDataRows(
    workOrderAsset?.attributes,
    generalDataLeft,
  );

  const dataRight = getAttributeDataRows(
    workOrderAsset?.attributes,
    generalDataRight,
  );

  return (
    <div styleName="section-box no-margin">
      <div styleName="section-title">General Data</div>
      <div styleName="inspection-content">
        <div styleName="left-box">
          {dataLeft.map(attribute => {
            return (
              <div styleName="data-row" key={attribute?.id}>
                <div styleName="data-title">{`${attribute?.name}:`}</div>
                <div styleName="data-content">
                  {attributeDisplayUtility.display(
                    attribute.value,
                    attribute.dataType,
                    attribute.unit,
                    !!attribute.changeId,
                    attribute.newValue,
                    attribute.thousandsSeparator,
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div styleName="right-box">
          {dataRight.map(attribute => {
            return (
              <div styleName="data-row" key={attribute?.id}>
                <div styleName="data-title">{`${attribute?.name}:`}</div>
                <div styleName="data-content">
                  {attributeDisplayUtility.display(
                    attribute.value,
                    attribute.dataType,
                    attribute.unit,
                    !!attribute.changeId,
                    attribute.newValue,
                    attribute.thousandsSeparator,
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GeneralData;
